import {
  drawerWidth,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  blackColor
} from "assets/jss/style.js";
const headerStyle = () => ({
  appBar: {
    boxShadow: "none !important",
    borderBottom: "0",
    marginBottom: "0",
    position: "relative !important",
    width: "100%",
    paddingTop: "5px",
    color: blackColor,
    border: "0",
    transition: "all 150ms ease 0s",
    minHeight: "55px",
    background: "rgba(0, 0, 0, 0) !important",
    fontWeight: "bolder"
  },
  container: {
    minHeight: "50px !important",
    display: "inline",
    width: "100%",
    padding: "0px !important",
    maxHeight: "80px"
  },
  flex: {
    flex: 0.3,
    width: "10%",
    display: "inline",
    verticalAlign: "top"
  },
  title: {
    width: "95%",
    margin: "auto",
    letterSpacing: "unset",
    lineHeight: "25px",
    fontSize: "18px",
    borderRadius: "3px",
    textTransform: "none",
    color: "inherit",
    "&:hover,&:focus": {
      background: "transparent"
    }
  },
  appResponsive: {
    top: "8px"
  },
  primary: {
    backgroundColor: primaryColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  info: {
    backgroundColor: infoColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  success: {
    backgroundColor: successColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  warning: {
    backgroundColor: warningColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  danger: {
    backgroundColor: dangerColor[0],
    color: whiteColor,
    ...defaultBoxShadow
  },
  botonMenu: {
    marginLeft: `calc(-65px + ${drawerWidth}px)`
  }
});

export default headerStyle;
